export default defineNuxtPlugin((nuxtApp) => {
  if (process.client) {
    const isLocalhost = window.location.hostname === 'localhost';
    const API_BASE_URL = isLocalhost ? 'http://localhost:5001/dss' : 'https://gateway.cloudrestfulapi.com/dss';
    const API_KEY = 'DU1eYMDG7j8yb199YDPg3';

    const apiRequest = async (endpoint, method = 'GET', data = null) => {
      try {
        // Retrieve clusterData from localStorage
        const clusterDataString = localStorage.getItem('clusterData');
        let ownerId = null;
        if (clusterDataString) {
          try {
            const clusterData = JSON.parse(clusterDataString);
            ownerId = clusterData?._id;
          } catch (parseError) {
            console.error('Error parsing clusterData from localStorage:', parseError);
          }
        }

        const headers = {
          'Content-Type': 'application/json',
        };

        // Add owner header if ownerId is available
        if (ownerId) {
          headers['owner'] = ownerId;
        }


        headers['user'] = '680333da41ceafbc0f7d6f2f';

        const options = {
          method,
          body: data ? JSON.stringify(data) : null,
          headers: headers,
        };
        const response = await $fetch(`${API_BASE_URL}/${endpoint}?key=${API_KEY}`, options);
        if (!response.success) {
          throw new Error(response.error || 'Request failed');
        }
        return response;
      } catch (error) {
        console.error(error);
        return null;
      }
    };

    // Add the apiRequest function to the Nuxt app context
    nuxtApp.provide('DSS', apiRequest);
  }
}); 